import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import _ from 'lodash'
import { messageActions } from '../../store/message'

const BASE_PATH = '/lottustech/certificadosdigitais'
const crud = build(validate, BASE_PATH)
const prefix = 'crudCertificadoDigital'

const newTypes = {
  RESET: `${prefix}reset`,
  SET_ADICIONANDO_ANEXO: `${prefix}adicionandoAnexo`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.setAdicionandoAnexo = (payload) => {
  return {
    type: types.SET_ADICIONANDO_ANEXO,
    payload,
  }
}

actions.processaCertificado = (event, password) => {
  return (dispatch, getState) => {
    if (event && event.files && event.files.length > 0) {
      dispatch(actions.setAdicionandoAnexo(true))
      const msgErro = 'Erro ao processar certificado'

      const file = event.files[0]
      const formData = new FormData()
      formData.append('file', file)

      if (password) {
        formData.append('password', password)
      }

      apiService
        .postFormData(`/lottustech/certificado/extrairDetalhes`, formData)
        .then((response) => {
          const dadosCertificado = _.get(response, 'data', null)
          
          // Preenche os campos do formulário com os dados extraídos
          if (dadosCertificado) {
            if (dadosCertificado.dadosTitular) {
              dispatch(actions.setField('dadosTitular', dadosCertificado.dadosTitular))
            }
            if (dadosCertificado.dadosEmissor) {
              dispatch(actions.setField('dadosEmissor', dadosCertificado.dadosEmissor))
            }
            if (dadosCertificado.dataInicio) {
              dispatch(actions.setField('dataInicio', new Date(dadosCertificado.dataInicio)))
            }
            if (dadosCertificado.dataExpiracao) {
              dispatch(actions.setField('dataExpiracao', new Date(dadosCertificado.dataExpiracao)))
            }
            if (dadosCertificado.chavePublica) {
              dispatch(actions.setField('chavePublica', dadosCertificado.chavePublica))
            }
            if (dadosCertificado.chavePrivada) {
              dispatch(actions.setField('chavePrivada', dadosCertificado.chavePrivada))
            }
          }

          event.options.clear()
          dispatch(actions.setAdicionandoAnexo(false))
        })
        .catch((error) => {
          dispatch(messageActions.messageShowMessages(makeMessages([msgErro], 'error')))
          dispatch(actions.setAdicionandoAnexo(false))
        })
    }
  }
}

const makeMessages = (messages, type) => {
  let sticky = type === 'error' || type === 'warn'
  return messages.map((message) => {
    return {
      sticky,
      severity: type,
      detail: message,
    }
  })
}

export { types, actions }
